import React from "react";
import { FiPlus, FiTrash2, FiSave, FiArrowLeft } from "react-icons/fi";
import JoditEditor from "jodit-react";

export default function Step2QuestionsForm({
  questions,
  totalLimit,
  onQuestionChange,
  onAddQuestion,
  onRemoveQuestion,
  onBack,
  onSave,
  loading,
}) {
  return (
    <div className="flex flex-col h-full bg-gray-50/50">
      {/* 1. Sub-Header (Stats) */}
      <div className="px-6 py-3 bg-blue-50 border-b border-blue-100 flex justify-between items-center shrink-0">
        <span className="text-sm font-semibold text-blue-800">
          Progress: <span className="font-bold">{questions.length}</span> /{" "}
          {totalLimit} Questions
        </span>
        <button
          onClick={onAddQuestion}
          className="flex items-center gap-2 text-xs font-bold text-white bg-blue-600 px-3 py-1.5 rounded-lg hover:bg-blue-700 transition-all shadow-sm"
        >
          <FiPlus /> Add New
        </button>
      </div>

      {/* 2. Scrollable Questions List (Takes remaining space) */}
      <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-6">
        {questions.map((q, idx) => (
          <div
            key={idx}
            className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
          >
            {/* Question Header */}
            <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-100">

              <div className="flex items-center gap-2">
                <span className="bg-gray-800 text-white text-xs font-bold px-2 py-1 rounded">
                  Q{idx + 1}
                </span>

                <select
                  value={q.questionType}
                  onChange={(e) =>
                    onQuestionChange(idx, "questionType", e.target.value)
                  }
                  className="text-[11px] font-bold uppercase px-2 py-1 rounded bg-indigo-100 text-indigo-700 border border-indigo-200"
                >
                  <option value="text">Text</option>
                  <option value="paragraph">Paragraph</option>
                </select>
              </div>

              {questions.length > 1 && (
                <button
                  onClick={() => onRemoveQuestion(idx)}
                  className="text-gray-400 hover:text-red-500 transition-colors p-1"
                >
                  <FiTrash2 size={16} />
                </button>
              )}
            </div>

            {/* Question Text */}
            <div className="mb-4">
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">
                Question Text
              </label>
              {q.questionType === "paragraph" ? (
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <JoditEditor
                    value={q.questionText}
                    onChange={(content) =>
                      onQuestionChange(idx, "questionText", content)
                    }
                  />
                </div>
              ) : (
                <textarea
                  className="w-full p-3 rounded-lg bg-gray-50 border border-gray-200
                 focus:border-blue-500 focus:bg-white focus:ring-2
                 focus:ring-blue-100 outline-none text-sm font-medium
                 transition-all min-h-[80px]"
                  placeholder="Type your question here..."
                  value={q.questionText}
                  onChange={(e) =>
                    onQuestionChange(idx, "questionText", e.target.value)
                  }
                />
              )}
            </div>

            <div className="mb-4">
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">
                Options Type
              </label>

              <select
                value={q.optionsType}
                onChange={(e) =>
                  onQuestionChange(idx, "optionsType", e.target.value)
                }
                className="w-full p-2.5 rounded-lg bg-gray-50 border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm font-semibold"
              >
                <option value="text">Text Options</option>
                <option value="image">Image (URL) Options</option>
              </select>
            </div>


            {/* Options Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {["A", "B", "C", "D"].map((opt) => (
                <div key={opt} className="relative">
                  <div className="flex">
                    <button
                      type="button"
                      onClick={() =>
                        onQuestionChange(idx, "correctOption", opt)
                      }
                      className={`w-10 flex items-center justify-center rounded-l-lg border-y border-l font-bold text-sm transition-all
                            ${q.correctOption === opt
                          ? "bg-emerald-500 border-emerald-500 text-white"
                          : "bg-gray-100 border-gray-200 text-gray-500 hover:bg-gray-200"
                        }`}
                    >
                      {opt}
                    </button>
                    <input
                      className={`flex-1 p-2.5 rounded-r-lg border text-sm outline-none transition-all
    ${q.correctOption === opt
                          ? "border-emerald-500 bg-emerald-50 text-emerald-900 font-medium"
                          : "border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                        }`}
                      placeholder={
                        q.optionsType === "image"
                          ? `Option ${opt} image URL`
                          : `Option ${opt} answer`
                      }
                      value={q.options[opt]}
                      onChange={(e) =>
                        onQuestionChange(idx, `options.${opt}`, e.target.value)
                      }
                    />

                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* Add More Button (Bottom of list) */}
        <button
          onClick={onAddQuestion}
          className="w-full py-4 border-2 border-dashed border-gray-300 rounded-xl text-gray-500 font-bold hover:border-blue-400 hover:text-blue-600 hover:bg-blue-50 transition-all flex items-center justify-center gap-2"
        >
          <FiPlus /> Add Another Question
        </button>
      </div>

      {/* 3. Footer Actions (Sticky Bottom inside Flex container) */}
      <div className="p-4 bg-white border-t border-gray-200 flex gap-3 shrink-0 z-20 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <button
          onClick={onBack}
          className="px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-xl hover:bg-gray-200 transition-colors flex items-center gap-2"
        >
          <FiArrowLeft /> Back
        </button>
        <button
          onClick={onSave}
          disabled={loading}
          className="flex-1 py-3 bg-emerald-600 text-white font-bold rounded-xl hover:bg-emerald-700 transition-all shadow-lg shadow-emerald-200 disabled:opacity-70 flex items-center justify-center gap-2"
        >
          {loading ? (
            <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <>
              <FiSave /> Save Section
            </>
          )}
        </button>
      </div>
    </div>
  );
}
